<template>
    <!-- 置换二手车-->
    <div class="wrapper success_base">
        <div class="success_title">
            <img src="../../assets/image/secondary/success.png" class="success_title_img">
            <p class="title">恭喜你报名成功</p>
            <p class="tip">请注意查收短信，接听客服电话。</p>
        </div>
        <div class="success_from">
            <div class="success_sign_form friend_form">
                <van-form @submit="onSubmit" style="background-color: transparent;padding: 10px 0">
                    <!-- <p class="vant_label mb10">您是否需要置换</p>
                    <van-radio-group v-model="checked" style="margin-bottom: 15px">
                        <van-radio name="1">置换二手车</van-radio>
                    </van-radio-group> -->
                    <p class="success_sign_form_title">置换二手车</p>
                    <p class="vant_label m20 color_black">请输入旧车车型</p>
                    <div class="field_outbox">
                        <van-field
                            :border="false"
                            v-model="brand"
                            name="旧车车型"
                            placeholder="请输入您的旧车车型"
                        >
                        </van-field>
                    </div>
                    <p class="vant_label m20 color_black">请选择上牌时间</p>
                    <div class="field_outbox">
                        <van-field
                            v-model="licensing"
                            name="上牌时间"
                            placeholder="请选择上牌时间"
                            @focus="changelicensing_show"
                        >
                            <template slot="right-icon">
                                <van-icon name="play" @click="changelicensing_show"/>
                            </template>
                        </van-field>
                    </div>
                    <p class="vant_label m20 color_black">请选择行驶里程</p>
                    <div class="field_outbox">
                        <van-field
                            v-model="mileage"
                            name="里程数"
                            placeholder="请选择行驶里程(万公里)"
                            right-icon="play"
                            @focus="changemileage_show"
                        >
                            <template slot="right-icon">
                                <van-icon name="play" @click="changemileage_show"/>
                            </template>
                        </van-field>
                    </div>

                    <el-divider></el-divider>
                    <div style="margin: 20px 0 10px 0" class="sub_txt">
                        <van-button round block type="info" native-type="submit">提交</van-button>
                    </div>
                </van-form>
            </div>
        </div>
        <div class="success_tail">
            <img v-if="tid!=5" src="../../assets/image/secondary/friend.png" alt="尾图"/>
            <img v-if="tid==5" src="../../assets/image/secondary/tail.png" alt="尾图"/>
        </div>
        <div class="success_button_copy" @click="clk_copy">
            <img src="../../assets/image/secondary/btn_copy.png" alt="复制分享"/>
            <img src="../../assets/image/new_img/pointer_01.png" alt="手" class="pointer_img">
            <div class="threeCircle threeCircle_1"></div>
            <div class="threeCircle threeCircle_2"></div>
            <div class="threeCircle threeCircle_3"></div>
        </div>
        <!-- 弹框-->
        <!-- 成功弹框-->
        <el-dialog :visible.sync="is_success" v-if="is_success" class="Successful" :show-close="false">
            <el-result icon="success" title="报名成功">
            </el-result>
        </el-dialog>

        <!-- 上牌时间选择-->
        <van-popup round v-model="licensing_show" position="bottom"
                   :safe-area-inset-bottom="true"
                   :style="{ height: '50%' }" :close-on-click-overlay="false">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="confirm_licensing"
                @cancel="changelicensing_show"
            />
        </van-popup>
        <!-- 里程数选择-->
        <van-popup round v-model="mileage_show" position="bottom"
                   :safe-area-inset-bottom="true"
                   :style="{ height: '50%' }" :close-on-click-overlay="false">
            <van-picker
                show-toolbar title="里程数(万公里)"
                :columns="mileage_columns"
                @confirm="confirm_mileage"
                @cancel="changemileage_show"
            />
        </van-popup>

    </div>
</template>

<script>
    import _wx from "@/common/_wx";
    import _geturl from "@/utils/_geturl";
    import lib_activity from "@/libs/lib_activity";
    import cache_url from "@/cache/cache_url";
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import Toast from "vant/lib/toast";
    import lib_clue from "@/libs/lib_clue";
    import _copyUrl from "@/common/_copyUrl";

    let action_form = {
        address: '',
    };
    export default {
        name: "success_ticket",
        components: {
        },
        data() {
            return {
                activity_id: 0, //活动ID
                tids: '', //模板id
                custom_car: 0,
                title: '', //
                share_theme: '', // 分享主题
                tid: 1, // 展会类型
                id: 0,
                theme: '',
                ui: {}, //
                stime: 0,
                etime: 0,
                address: '', // 活动地点
                is_stop: false, //项目是否结束
                form_address: '',
                is_success: false, //成功弹框
                checked: '1', //是否置换二手车
                brand: '', //车型
                licensing: '', // 上牌时间
                mileage: '', //里程数
                licensing_show: false,
                mileage_show: false,
                currentDate: undefined,
                minDate: undefined,
                maxDate: new Date(),
                mileage_columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
            }
        },

        created() {
            // 最小年限
            let now = new Date();
            let now1 = new Date();
            const before15 = now.setFullYear((now.getFullYear() - 15));
            this.minDate = new Date(before15);
            // 打开面板默认年
            const middleYear = now1.setFullYear((now1.getFullYear() - 8));
            this.currentDate = new Date(middleYear);

            this.activity_id = _geturl("activity_id");//项目
            this.id = _geturl('id');
            //获取项目信息
            lib_activity.info(this.activity_id, this.tids, this.init_info);
        },
        methods: {

            //初始化项目信息
            //初始化项目信息 data是lib_activity.info的response.data
            init_info(data) {
                console.log(data)
                this.title = data.activity.theme;
                document.title = this.title;
                this.share_theme = data.activity.share_theme;
                this.stime = data.activity.stime;
                this.etime = data.activity.etime;
                this.stime_etime = _time._range_date(this.stime*1000, this.etime*1000);
                this.address = data.activity.address;
                this.tid = data.activity.tid;
                this.ui = data.ui;
                // 项目结束
                if (!data.activity.state || _time._current() > data.activity.etime) {
                    this.is_stop = true;
                    return;
                }

                // 分享： ui存在再分享
                if (_object._length(this.ui) > 0) {
                    this.share();
                }

            },
            // 微信分享
            share() {
                let that = this;
                lib_activity.share(function (data) {
                    let options = {};
                    options.title = that.title;
                    options.desc = that.share_theme;
                    options.link = window.location.href;
                    options.image = that.ui.share;

                    _wx.js_api(data, _wx.share, options);
                })
            },

            // 清空表单
            resetForm() {
                this.brand = '';
                this.licensing = '';
                this.mileage = '';
            },
            onSubmit() {
                if (this.brand == '') {
                    Toast('请输入您的旧车车型');
                    return;
                }
                if(this.brand && this.brand.length > 50) {
                    Toast('请输入正确的旧车车型');
                    return;
                }

                let params = {
                    id: this.id,
                    form_usedcar:  this.brand,
                    form_licensing:  this.licensing,
                    form_mileage: this.mileage,
                };
                let that = this;
                lib_clue.supply(params,function (data) {
                    setTimeout(()=>{
                        that.is_success = true;
                        setTimeout(()=>{
                            that.is_success = false;
                            that.resetForm()
                        },1000)
                    },500)
                })
            },

            // 复制
            clk_copy() {
                let url = cache_url.empty() ? window.location.href : cache_url.get();
                _copyUrl.copyUrl("@ [" + this.theme + "] 我已领取了门票，和我一起来看看!>>" + ' ' + url)
            },

            // 上牌时间相关
            changelicensing_show() {
                document.activeElement.blur();
                this.licensing_show = !this.licensing_show;
            },
            // 对时间进行格式化处理
            formatter(time) {
                let year = time.getFullYear();
                let month = (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
                return year + '-' + month
            },
            // 时间选择完成
            confirm_licensing(values) {
                this.licensing = this.formatter(new Date(values));
                this.changelicensing_show();
            },

            // 里程数相关
            changemileage_show() {
                document.activeElement.blur();
                this.mileage_show = !this.mileage_show;
            },
            // 里程数选择完成
            confirm_mileage(values) {
                this.mileage = values;
                this.changemileage_show();
            },

        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/style/secondary/base.less";
    @import "../../assets/style/autoshow/form.less";
    // form
    @import "../../assets/style/common/successful.less"; // 成功
    .mt0 {
        margin-top: 0px;
    }

    .m20 {
        margin: 20px 0;
    }

    .color_black{
        color: #000;
        font-size: 26px;
        margin-bottom: 12px;
    }

    .replace_form{
        position: relative;
        :deep .van-field__value {
            padding-left: 16px;
        }

        :deep .van-field__right-icon {
            transform: rotate(90deg);
            margin-right: 0;
            color: #a0a4ac;
        }
    }

    .form_btn_img {
        width: 100%;
        height: auto;
        margin-top: 10px;

        img {
            display: inline-block;
            width: 100%;
        }
    }
    .mb10{
        margin-bottom: 10px;
    }
.sub_txt{
    .van-button--info{
        width: 100%;
        height: 96px;
        text-align: center;
        line-height: 96px;
        border-radius: 50px;
        color: #fff;
        background: linear-gradient(to right, #ff473c, #ffb746);
        border: none;
        box-shadow: 2px 10px 12px rgba(255, 71, 60, 0.2);
    }
    .van-button__text{
        letter-spacing: 2px;
        font-size: 40px;
    }
}
</style>
